module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    attrs: {
      "name": "email"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.runner.runner ? _vm.runner.runner.user.email : null))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newemail),
      expression: "newemail"
    }],
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "id": "newemail",
      "maxlength": "255",
      "name": "newemail",
      "Placeholder": ""
    },
    domProps: {
      "value": (_vm.newemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newemail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    on: {
      "click": function($event) {
        return _vm.Save(_vm.newemail)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bef3890e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/EditEmail.vue
// module id = 1710
// module chunks = 2